<template>
	<v-container>
		<v-card class="shadowCard">
			<v-card-title primary-title>
			  <span class="text-caption">Datos personales</span>
			</v-card-title>
			<v-card-text>
			  
				<v-form
			    ref="form"
			    v-model="valid"
			    lazy-validation
			  >
			  	<v-row>
			  		<v-col cols="12" class="pb-0 px-4">
					    <v-text-field
					    	:disabled="disabled"
					      v-model="perfil.nombre"
					      :rules="[rules.required]"
					      label="Nombre"
					      required
					      rounded
					      filled
					      color="primary"
					      hide-details
					    ></v-text-field>
			  		</v-col>

			  		<v-col cols="12" class="pb-0">
					    <v-text-field
					    	:disabled="disabled"
					      v-model="perfil.apellido_paterno"
					      :rules="[rules.required]"
					      label="Apellido paterno"
					      required
					      rounded
					      filled
					      color="primary"
					      hide-details
					    ></v-text-field>
						</v-col>

						<v-col cols="12" class="pb-0">
					    <v-text-field
					    	:disabled="disabled"
					      v-model="perfil.apellido_materno"
					      label="Apellido materno"
					      rounded
					      filled
					      color="primary"
					      hide-details
					    ></v-text-field>
						</v-col>

						<v-col cols="6"  class="pb-0">
					    <v-text-field
					    	:disabled="disabled"
					      v-model="perfil.edad"
					      :rules="[rules.required]"
					      label="Edad"
					      required
					      rounded
					      filled
					      color="primary"
					      hide-details
					    ></v-text-field>
						</v-col>

						<v-col cols="6" class="pb-0">
							<v-text-field
					    	:disabled="disabled"
					      v-model="perfil.telefono"
					      :rules="[rules.required]"
					      label="Teléfono"
					      required
					      rounded
					      filled
					      color="primary"
					      hide-details
					    ></v-text-field>
						</v-col>
			  	</v-row>
			  </v-form>
			</v-card-text>
		</v-card>
	</v-container>
</template>
<script>
	import { mapActions, mapGetters } from 'vuex'

  export default {
  	
  	props:[
			'perfil'
	  ],

    data: () => ({
    	disabled: true,
      valid: true,
    	
    	// Datos del usuario
    	usuario:'',
    	password:'',

      rules: {
        required: value => !!value || 'Requerido.'
      },

    }),

    computed:{
    	...mapGetters( 'login', [ 'getUsuarioLMS', 'getDatosUsuarioLMS']),
    },

    methods: {
    	...mapActions( 'login', [ 'grabarUsuario', 'grabarDatosUsuario' ]),
    },
  }
</script>
<style scoped>
	.shadowCard{
		border-radius: 15px !important; 
		box-shadow: 0 20px 27px 0 rgba(0,0,0,0.15)  !important;
	}

</style>